import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {/* Colonne 1 : À propos */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">CabGolf</h3>
            <p className="text-xs text-gray-400">
              Plateforme de coaching golf en ligne par Laurent Cabanne. 
              Programmes d'entraînement, analyses de swing et suivi personnalisé.
            </p>
          </div>

          {/* Colonne 2 : Liens légaux */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">Informations légales</h3>
            <ul className="space-y-2 text-xs">
              <li>
                <Link to="/privacy-policy" className="hover:text-green-500 transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-green-500 transition-colors">
                  Conditions d'utilisation (CGU)
                </Link>
              </li>
              <li>
                <Link to="/terms-of-sale" className="hover:text-green-500 transition-colors">
                  Conditions de vente (CGV)
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 : Contact */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">Contact</h3>
            <div className="flex items-center gap-2 text-xs text-gray-400">
              <Mail size={16} className="text-green-500" />
              <a href="mailto:contact@cabgolf.fr" className="hover:text-green-500 transition-colors">
                contact@cabgolf.fr
              </a>
            </div>
          </div>
        </div>

        {/* Séparateur et Copyright */}
        <div className="border-t border-gray-800 pt-4 text-center">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} CabGolf. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}

